<template>
    <!-- 风险等级四色图 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/grade_chart_list'}" @click="$Common.pageJump('/grade_chart_list',3)">
                四色图列表
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/grade_chart_details'}"  @click="$Common.pageJump('/grade_chart_details',3)">
                四色图详情
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'RiskGradeChart',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
@import '/css/base.css';
</style>